
import { defineComponent } from 'vue';
import { useProjectManagerStore } from '../store';
import {
  allWorkspacesStateSingleton,
  setWorkspaceName,
  updateWorkspaceMeta
} from '@/firebase/database';
import { v4 } from 'uuid';
import {
  saveLaunchFiles,
  savePackage,
  saveWorkspaceConnection
} from '@/firebase/databaseDependencyInjectables';
import authStore from '@/firebase/auth';
import {
  getStripeCustomerSubscription,
  getSubscriptionQuantity
} from '@/stripe/stripeSubscription';
import Stripe from 'stripe';
import { ConnectionDetails } from '@/modules/controlCenterModule/store';

export default defineComponent({
  name: 'NewWorkspacePage',
  data(): {
    workspaceName: string;
    pmStore: any;
    inputErr: string;
    userSubscription: undefined | Stripe.Subscription;
    workspaces: any;
    prodLoaded: boolean;
  } {
    return {
      workspaceName: '',
      pmStore: useProjectManagerStore(),
      workspaces: allWorkspacesStateSingleton(),
      inputErr: '',
      userSubscription: undefined,
      prodLoaded: true
    };
  },
  // async mounted() {
  // if (!authStore.stripeId) {
  //   this.$router.push('/login');
  //   return;
  // }
  // try {
  //   this.userSubscription = await getStripeCustomerSubscription(
  //     authStore.stripeId
  //   );
  //   console.log(this.userSubscription);
  // } catch {
  //   console.error('failed to load product');
  // }
  // this.prodLoaded = true;
  // },
  methods: {
    onExit(): void {
      this.$router.push('/projectManager');
    },
    onSave(): void {
      if (this.workspaceName.trim().length === 0) {
        this.inputErr = 'Name cannot be empty';
        return;
      }
      if (
        this.workspaces &&
        this.workspaces.info &&
        Object.entries(this.workspaces.info).some(
          (wsInfo) => (wsInfo[1] as any).name == this.workspaceName
        )
      ) {
        this.inputErr = 'Workspace names cannot be duplicates';
        return;
      }
      const workspaceId = v4();
      setWorkspaceName(workspaceId, this.workspaceName);
      updateWorkspaceMeta(workspaceId, { timeCreated: new Date().getTime() });
      if (
        this.$route.query.templateId &&
        typeof this.$route.query.templateId === 'string'
      ) {
        const pmStore = useProjectManagerStore();
        const currTemplate = pmStore.getTemplate(
          this.$route.query.templateId as string
        );
        console.log(currTemplate);
        if (currTemplate) {
          for (const pkg of currTemplate?.packages) {
            savePackage(workspaceId, pkg.id, pkg);
          }
          currTemplate.connections.forEach((con: ConnectionDetails) =>
            saveWorkspaceConnection(workspaceId, con)
          );
          saveLaunchFiles(workspaceId, currTemplate.launchFiles);
        }
      }
      this.$router.push('/controlCenter/' + workspaceId);
    },
    canCreate() {
      // const pmStore = useProjectManagerStore();
      // return pmStore.canCreateWorkspace(this.userSubscription);
      return true;
    }
    // getCreationFailureText() {
    //   const workspacesInfo = allWorkspacesStateSingleton();
    //   if (!this.userSubscription) {
    //     return 'The MiROS free trial only has access to one workspace. Please upgrade your subscription to create more workspaces.';
    //   }
    //   if (
    //     Object.keys(workspacesInfo.info).length >=
    //     (getSubscriptionQuantity(this.userSubscription) || 1) * 5
    //   ) {
    //     return `You have exceeded the maximum number of workspaces for this subscription, which is currently ${
    //       (getSubscriptionQuantity(this.userSubscription) || 1) * 5
    //     }. Please upgrade your subscription to create more workspaces.`;
    //   }
    //   return 'Failed to get subscription data.';
    // }
  }
});
